import React, { useMemo } from "react";
import "./index.scss";
import Formula3DPreview from "../../FormulaGenerator/Formula3DPreview";
import { educationPack1, educationPack2 } from "./educationPacks";

const EducationStep2 = ({
  stepId
}) => {
  const {
    eduPack,
    eduSwitchers
  } = useMemo(() => {
    switch (stepId) {
      case "PSP_ET_e1_e2":
        return {
          eduPack: educationPack1,
          eduSwitchers: ["top", "bottom", "base", "fixedProstheses", "implants", "abutments", "multiunitAbutments", "screws"]
        };

      case "PSP_EM_e1_e2":
        return {
          eduPack: educationPack2,
          eduSwitchers: ["top", "bottom", "base", "fixedProstheses"]
        };

      default:
        return educationPack1;
    }
  }, [stepId]);
  return /*#__PURE__*/React.createElement("div", {
    className: "educationStep2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "educationStep2-container"
  }, /*#__PURE__*/React.createElement(Formula3DPreview, {
    stlPack: eduPack,
    availableSwitchers: eduSwitchers
  })));
};

export default EducationStep2;